import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PaymentResult } from "@/components/PaymentResult";
import HomePage from "@/pages/HomePage";
import PricesPage from "@/pages/PricesPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [payment, setPayment] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    const state = p.get("payment");
    return state ? { state, sessionId: p.get("session_id") } : null;
  });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (payment?.state === "cancelled") {
      toast.error("Payment cancelled — your booking is saved. You can try again anytime.");
      window.history.replaceState({}, "", window.location.pathname);
      setPayment(null);
    }
  }, [payment]);

  const clearPayment = () => {
    window.history.replaceState({}, "", window.location.pathname);
    setPayment(null);
  };

  if (payment?.state === "success" && payment.sessionId) {
    return (
      <div className="min-h-screen bg-white font-body text-ink antialiased">
        <PaymentResult sessionId={payment.sessionId} onDone={clearPayment} />
        <Toaster position="top-center" richColors />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-white font-body text-ink antialiased">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
